var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgS1ArrowBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 32,
    viewBox: "0 0 30 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.823119 31.4492C0.565715 31.2341 0.358599 30.9651 0.216355 30.6613C0.0741109 30.3575 0.000196552 30.0262 -0.000184965 29.6907C0.000130041 29.4222 0.0466748 29.1558 0.137409 28.903L4.33304 17.1553L15.2333 17.1553C15.5402 17.1553 15.8345 17.0333 16.0516 16.8163C16.2686 16.5993 16.3905 16.3049 16.3905 15.998C16.3905 15.6911 16.2686 15.3967 16.0516 15.1797C15.8345 14.9627 15.5402 14.8407 15.2333 14.8407L4.33305 14.8407L0.137404 3.09298C-0.0210641 2.64923 -0.0403165 2.16768 0.0822168 1.71269C0.20475 1.2577 0.463232 0.850941 0.82312 0.546784C1.18301 0.242626 1.62716 0.0555549 2.0962 0.0105718C2.56525 -0.0344113 3.03686 0.0648364 3.448 0.295051L27.8827 13.9785C28.2417 14.1795 28.5406 14.4726 28.7487 14.8276C28.9567 15.1825 29.0664 15.5866 29.0664 15.998C29.0664 16.4095 28.9567 16.8135 28.7487 17.1684C28.5406 17.5234 28.2417 17.8165 27.8827 18.0176L3.44793 31.701C3.03757 31.9338 2.56544 32.0346 2.09578 31.9895C1.62612 31.9445 1.18174 31.7558 0.823119 31.4492Z",
    fill: "#0D998C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgS1ArrowBtn);
export default __webpack_public_path__ + "static/media/s1-arrow-btn.9c20a8264136a812a25737c6bd5b24da.svg";
export { ForwardRef as ReactComponent };